import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { AccordionComponent } from './components/accordion/accordion.component';

@NgModule({
  declarations: [AccordionComponent],
  imports: [CommonModule, SharedModule],
  exports: [AccordionComponent],
})
export class AccordionModule {}
